module.exports = __webpack_public_path__ + "img/4.648a8ef3.png";